<template>
<div>

<div class="modal" id="staticBackdropBookingForm" tabindex="-1"  data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-lg">
    <div class="modal-content border-primary">
      <div class="modal-header bg-warning border-primary">
        <h5 class="modal-title">
          <i style="color:black" class="fas fa-shipping-fast mr-3"></i>
          RICHIESTA DI TRASFERIMENTO A <strong class="ml-2"> {{ booking.sender.toUpperCase() }}</strong>
        </h5>               
      </div>
      <div class="modal-body">
        <alert-box @close="msg.title=''" v-bind:msg="msg" class="mt-2 mb-2"  ></alert-box>  
          <h4 class="text-center">colore <strong class="mr-2 ml-2"> {{ booking.color }}</strong>  misura <strong class="ml-2">{{ booking.size }}.</strong> </h4>
      </div>
      <div class="modal-footer">
        
        <button @click="$emit('close')" type="button" class="btn btn-secondary" data-dismiss="modal">
          <i style="color:#FFCC00" class="fas fa-reply mr-3"></i>
          CHIUDI</button>
        <button :disabled="bt_spinner || done" @click="submit()" type="button" class="btn btn-primary">
          <i style="color:#FFCC00" class="far fa-check-circle mr-3"></i>
          RICHIEDI
          <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-3" role="status" aria-hidden="true"></span>
        </button>

        
      </div>
    </div>
  </div>
</div>
</div>
</template>

<script>

  import api                   from '@/api'
  import { mapGetters }        from 'vuex'
  import alertBox              from '@/components/common/AlertBox.vue'
  
  export default {
     props: ['booking'],
     components: {alertBox},
    data () {
      return {
        
         bt_spinner     : false,
           msg : {
            title : '',
            body  : '',
            type  : 0
          },
          done    : false
        
      }
    },
    
    computed: {
      
      ...mapGetters(['storeId']) ,   
    },

    created () 
    { 
      console.log(this.booking)
      this.$nextTick(()  => {              
    
        $('#staticBackdropBookingForm').modal('show')
       
    })  
    },
    methods: 
    {
    
        
      async submit()
      {
        const d          = new Date()
        const bookDate   = d.toLocaleString()
        this.bt_spinner  = true
        this.msg.title   = ''
        const data       = {'productId' : this.booking.productId,
                          'colorId'     : this.booking.colorId,
                          'size'        : this.booking.size,
                          'senderId'    : this.storeId,
                          'storeId'     : this.booking.storeId,
                          'bookDate'    : bookDate
                          }
                          
        const sp         = {'sp' : 'spCreateStockBooking'}
        const json       = Object.assign(data, sp)
        await api.post(json).then(res => {
     
          if(res.status==200)
            {
                

              const sku = res.data.recordsets[0][0].sku
              const brand = res.data.recordsets[0][0].brand
              const category = res.data.recordsets[0][0].category
              const department = res.data.recordsets[0][0].department
              const season = res.data.recordsets[0][0].season + ' ' + res.data.recordsets[0][0].season_year
              const color = res.data.recordsets[0][0].color
              const size = res.data.recordsets[0][0].size
              const barcode = res.data.recordsets[0][0].barcode

              api.postMsg({"date" : bookDate,
                         "time" : '', 
                         "description1" : this.booking.store.toUpperCase() ,
                         "description2" : {'brand':brand,
                                            'category':category,
                                            'department':department,
                                            'sku':sku,
                                            'season':season,
                                            'color':color,
                                            'size':size,
                                            'barcode':barcode},
                         
                         "shippedFrom"  : this.storeId,
                         'shippedTo'    : this.booking.storeId,
                         'rowId'        : Math.random() * this.storeId,
                         'typeId'       : 'booking' })  
            

                this.done      = true
                this.msg.title = 'RICHIESTA DI TRASFERIMENTO'
                this.msg.body  = 'EFFETTUATA.'
                this.msg.type  = 0     
            }
           else if(res.status==500)
           {
                console.log(res.data) 
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res.data
                this.msg.type  = 1                   
           } 
           else
            {
                console.log('Network Error.')    
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res
                this.msg.type  = 1              
                 
            } 
          

          }).catch(err => {
              
              console.log(err.message)    
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = err.message
              this.msg.type  = 1
              
          }).finally(() => {
              this.bt_spinner = false
        });
        

          
      },
          

    }
  }
</script>
<style scoped>

h4 
{
  font-family : 'Roboto Condensed';
  font-size   : 24px;
};

</style>
